// 引入插件
import { defineAsyncComponent } from 'vue'
// 装载全局组件
export default function (Vue) {
  Vue.component('public-upload-file', () => import('@/components/public/public-upload-file'))
}




// WEBPACK FOOTER //
// ./src/components/global-components.js